import { CSSProperties, ChangeEvent } from 'react';
import { useController, useFormContext } from 'react-hook-form';

type TProps = {
  id?: string;
  value?: string | number;
  name: string;
  className?: string;
  disabled?: boolean;
  readOnly?: boolean;
  afterChange?: (value: string | number | boolean | string[]) => void;
  multiple?: boolean;
  inputStyle?: CSSProperties;
  checked?: boolean;
};

const FormCheckboxInput = ({
  id,
  value,
  name,
  className,
  disabled,
  readOnly,
  afterChange,
  multiple = false,
  inputStyle,
  checked,
}: TProps) => {
  const { control } = useFormContext();
  const {
    field: { value: fieldValue, onChange },
  } = useController({
    name,
    control,
  });

  const onChangeInput = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.checked ? value : '';
    onChange(newValue);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    afterChange?.(newValue as any);
  };

  const onChangeMultipleInput = (e: ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    let updatedValue;
    if (fieldValue.includes(newValue)) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      updatedValue = fieldValue.filter((v: any) => v !== newValue);
    } else {
      updatedValue = [...fieldValue, newValue];
    }
    onChange(updatedValue);
    afterChange?.(updatedValue);
  };

  return (
    <input
      onChange={multiple ? onChangeMultipleInput : onChangeInput}
      id={id}
      type="checkbox"
      className={className}
      value={value}
      disabled={disabled || readOnly}
      checked={
        checked
          ? checked
          : multiple
          ? fieldValue?.includes(value)
          : fieldValue === value
      }
      style={inputStyle}
    />
  );
};

export default FormCheckboxInput;
